import { IFetchOriginsProtocol, IFetchOriginsProtocolRequest, IFetchOriginsProtocolResponse } from "../../protocols/origin/IFetchOriginsProtocol";
import { IOriginsRepository } from "../../repositories/IOriginsRepository";

export class FetchOriginsUseCase implements IFetchOriginsProtocol {
  constructor(private originsRepository: IOriginsRepository){}
  async execute(_: IFetchOriginsProtocolRequest): Promise<IFetchOriginsProtocolResponse> {
    const origins = await this.originsRepository.fetchMany()

    return {
      origins
    }
  }
}